import React, { useState } from "react";
import { tss } from "tss-react";
import { Typography, Input, InputAdornment, MenuItem, Grid, Menu } from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";
import { Scrollbars } from "react-custom-scrollbars";
import { getGradients } from "constants/viewer";
import { getGradientImage } from "actions/ViewerTools";

const maxGradientMenu = 500;

const useStyles = tss.create({
    select: {
        height: 40,
        display: "inline-flex",
        alignItems: "center",
        textOverflow: "ellipsis",
        textAlign: "left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        cursor: "default",
    },
    gradientImage: {
        transform: "rotate(90deg)",
        width: "300px",
        height: "300px",
    },
    gradientLabel: {
        marginTop: 1,
        overflowX: "hidden",
        textOverflow: "ellipsis",
        fontSize: 12,
    },
    gradientImageContainer: {
        height: 30,
        overflow: "hidden",
    },
});

var scrollbar: any;

type IColorGradient = {
    colorGradientId: string;
    setColorGradient: (gradientId: string) => void;
    openMenu?: boolean;
    handleCloseGradientMenu?: () => void;
    style?: React.CSSProperties;
    menuWidth?: number;
};

export default function ColorGradient(props: IColorGradient) {
    const { classes } = useStyles();
    const { colorGradientId, setColorGradient, openMenu, style = { width: 270 }, menuWidth = 300 } = props;
    let inputRef: any;
    const [anchorEl, setAnchorEl] = useState(null);

    const handleCloseGradientMenu = () => {
        setAnchorEl(null);
        if (props.handleCloseGradientMenu) {
            props.handleCloseGradientMenu();
        }
    };

    const handleGradientMenu = (evt: any) => {
        setAnchorEl(evt.currentTarget);
    };

    React.useEffect(() => {
        if (openMenu) {
            setAnchorEl(inputRef);
        }
    }, [openMenu, inputRef]);

    const handleWheel = (event: any) => {
        if (scrollbar) {
            var top = scrollbar.getScrollTop();
            if (event.deltaY < 0) {
                top -= 10;
            } else if (event.deltaY > 0) {
                top += 10;
            }
            scrollbar.scrollTop(top);
        }
    };
    return (
        <div>
            <Input
                ref={(elm: any) => (inputRef = elm)}
                value={colorGradientId || "color"}
                className={classes.select}
                style={{ fontSize: 14, ...style }}
                onClick={handleGradientMenu}
                endAdornment={
                    <InputAdornment position="end">
                        <ArrowDropDown fontSize="small" />
                    </InputAdornment>
                }
            />
            <Menu
                anchorEl={anchorEl}
                keepMounted
                aria-autocomplete={"none"}
                autoFocus={false}
                disableAutoFocusItem={true}
                open={Boolean(anchorEl)}
                onClose={handleCloseGradientMenu}
                MenuListProps={{
                    style: {
                        width: menuWidth,
                        overflow: "hidden",
                        maxHeight: maxGradientMenu,
                    },
                }}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Scrollbars
                    ref={(elm: any) => (scrollbar = elm)}
                    autoHeight
                    autoHeightMax={maxGradientMenu - 20}
                    style={{ overflowX: "hidden", width: menuWidth }}
                    onWheel={handleWheel}
                >
                    {getGradients().map((attributeId: any) => (
                        <MenuItem
                            key={attributeId}
                            value={attributeId}
                            title={attributeId}
                            style={{ width: menuWidth, marginRight: 20, paddingLeft: 10, paddingRight: 10 }}
                            onClick={(e: any) => {
                                setColorGradient(String(attributeId));
                                setAnchorEl(null);
                            }}
                        >
                            <Grid container direction="row">
                                <div className={classes.gradientImageContainer}>
                                    <img
                                        src={getGradientImage(attributeId)}
                                        className={classes.gradientImage}
                                        alt="Gradient"
                                    />
                                </div>
                                <Typography className={classes.gradientLabel} style={{}}>
                                    {attributeId}
                                </Typography>
                            </Grid>
                        </MenuItem>
                    ))}
                </Scrollbars>
            </Menu>
        </div>
    );
}
